import react from '@heroicons/react';

const documents = [
  {
    title: 'W9',
    size: '10 MB',
    previewUrl: '#',
  },
  {
    title: 'EIN Number',
    size: '10 MB',
    previewUrl: '#',
  },
];

const Desc = [
  {
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum',
  },
];
const companyOverview = [
  {
    companyReg: '123456789',
    establishmentYear: '2014',
    contactNumber: '123456789',
    emailAddress: 'buyer@gmail.com',
    natureOfBusiness: 'Manufacturer',
    industryType: 'industryType',
    revenue: 'revenue',
    marketCap: 'Market Cap',
    noOfEmployees: '50',
    website: 'www.buyer.com',
  },
];
const businessVerification = [
  {
    businessCreditScore: '90',
    BBARating: 'A+',
    DBReport: '123456789',
  },
];
const keyContactPerson = [
  {
    fullName: 'Somesh Sharma',
    email: 'somesh@gmail.com',
    phone: '123456',
  },
];
const DocumentCard = ({ title, size, onView }) => (
  <div className="w-80 h-48 bg-white rounded-lg shadow-md border p-4 flex flex-col justify-between">
    {/* Image Placeholder */}
    <div className="h-20 w-full bg-gray-100 rounded mb-2" />

    {/* Title and Size - Left Aligned */}
    <div className="text-sm font-semibold text-gray-800 text-left">{title}</div>
    <div className="text-xs text-gray-500 text-left">{size}</div>

    {/* View Button */}
    <button
      onClick={onView}
      className="mt-2 w-full border border-darkPurple text-darkPurple font-semibold py-1 rounded hover:bg-gray-100"
    >
      View
    </button>
  </div>
);

const BuyerProfileScreen = () => {
  return (
    <div>
      <div className="bg-gray-50 rounded-lg py-2">
        <div className="flex justify-between p-4">
          <div className="flex gap-4">
            <img src="C:\Users\kapoo\OneDrive\Pictures\Screenshots\Screenshot (1).png"></img>
            <div className="flex flex-col">
              <div className="text-xl font-semibold">Ronald Industries</div>
              <div className="text-sm">Location</div>
              <div className="text-sm text-gray-400">
                MakerSharks verified via{' '}
                <span className="text-darkPurple">Crunchbase</span>
              </div>
            </div>
          </div>
          <div>
            <button className="p-2 px-3 bg-darkPurple mt-4 rounded text-white hover:bg-darkerPurple">
              View RFQ
            </button>
          </div>
        </div>
        <div className="p-4 pt-2">
          <div className="text-xs text-gray-400">Company Description</div>
          <div className="bg-white text-sm p-2 mt-2 rounded">
            {Desc[0].description}
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded p-4 mt-8 rounded-lg">
        <div className="bg-gray-100 p-2 text-darkPurple font-semibold">
          Company Overview
        </div>

        <div className="flex flex-col mt-6">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">
                Company Registration / Tax ID
              </div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].companyReg}
              </div>
            </div>
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">Establishment Year</div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].establishmentYear}
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-8 mt-8">
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">Contact Number</div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].contactNumber}
              </div>
            </div>
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">Email Address</div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].emailAddress}
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row gap-8 mt-8">
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">Nature of Business</div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].natureOfBusiness}r
              </div>
            </div>
            <div className="flex flex-col flex-1">
              <div className="text-xs text-gray-400">Industry Type</div>
              <div className="bg-white p-2 mt-2 rounded w-full">
                {companyOverview[0].industryType}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <div className="text-sm text-gray-500">Size</div>
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="flex flex-col flex-1 mt-2">
              <div className="text-xs text-gray-400">Revenue</div>
              <div className="bg-white p-2 mt-2 rounded">
                {companyOverview[0].revenue}
              </div>
            </div>
            <div className="flex flex-col flex-1 mt-2">
              <div className="text-xs text-gray-400">Market Cap</div>
              <div className="bg-white p-2 mt-2 rounded">
                {companyOverview[0].marketCap}
              </div>
            </div>
            <div className="flex flex-col flex-1 mt-2">
              <div className="text-xs text-gray-400">No of Employees</div>
              <div className="bg-white p-2 mt-2 rounded">
                {companyOverview[0].noOfEmployees}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6">
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="flex flex-col flex-1 mt-2">
              <div className="text-xs text-gray-400">Website</div>
              <div className="bg-white p-2 mt-2 rounded w-1/2">
                {companyOverview[0].website}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 bg-gray-50 ">
        <div className="flex flex-wrap gap-12">
          {documents.map((doc, index) => (
            <DocumentCard
              key={index}
              title={doc.title}
              size={doc.size}
              previewUrl={doc.previewUrl}
            />
          ))}
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-xl mt-6">
        <div className="bg-gray-100 p-2 font-semibold text-darkerPurple mb-6">
          Business Verification
        </div>

        <div className="mb-6">
          <div className="text-sm text-gray-500 mb-1">
            Business Credit Score
          </div>
          <div className="flex items-center">
            <div className="bg-white p-2 rounded w-full max-w-md">
              {businessVerification[0].businessCreditScore}
            </div>
            <a
              href="#"
              className="ml-4 text-sm text-darkerPurple hover:whitespace-nowrap"
            >
              View Report
            </a>
          </div>
        </div>

        <div className="mb-6">
          <div className="text-sm text-gray-500 mb-1">BBB Rating</div>
          <div className="flex items-center">
            <div className="bg-white p-2 rounded w-full max-w-md">
              {businessVerification[0].BBARating}
            </div>
            <a
              href="#"
              className="ml-4 text-sm text-darkerPurple hover:whitespace-nowrap"
            >
              View BBB Profile
            </a>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-500 mb-1">D&B Report</div>
          <div className="flex items-center">
            <div className="bg-white p-2 rounded w-full max-w-md">
              {businessVerification[0].DBReport}
            </div>
            <a
              href="#"
              className="ml-4 text-sm text-darkerPurple hover:whitespace-nowrap"
            >
              View D&B Profile
            </a>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 p-6 rounded-xl mt-8">
        <div className="bg-gray-100 p-2 font-semibold text-darkerPurple mb-6">
          Key Contact Person
        </div>

        <div className="mb-6">
          <div className="text-sm text-gray-500 mb-1">Full Name</div>
          <div className="bg-white p-2 rounded w-full max-w-md">
            {keyContactPerson[0].fullName}
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-6">
          <div className="flex-1">
            <div className="text-sm text-gray-500 mb-1">Email Address</div>
            <div className="bg-white p-2 rounded w-full">
              {keyContactPerson[0].email}
            </div>
          </div>

          <div className="flex-1">
            <div className="text-sm text-gray-500 mb-1">Phone Number</div>
            <div className="bg-white p-2 rounded w-full">
              {keyContactPerson[0].phone}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 p-6 rounded-xl mt-8">
        {/* Section Title */}
        <div className="bg-gray-100 p-2 font-semibold text-darkerPurple mb-6">
          Previous Manufacturers
        </div>

        {/* Manufacturer 1 */}
        <div className="flex items-start mb-4">
          <div className="text-lg font-semibold mr-3">1.</div>
          <div className="bg-gray-100 p-4 rounded w-full">
            <div className="text-base font-semibold mb-2">
              TechForge Pvt Ltd
            </div>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="flex-1">
                <div className="text-sm text-gray-500 mb-1">Email Address</div>
                <div className="bg-white p-2 rounded">somesh@gmail.com</div>
              </div>
              <div className="flex-1">
                <div className="text-sm text-gray-500 mb-1">Project Type</div>
                <div className="bg-white p-2 rounded">CNC Machining</div>
              </div>
            </div>
          </div>
        </div>

        {/* Manufacturer 2 */}
        <div className="flex items-start">
          <div className="text-lg font-semibold mr-3">2.</div>
          <div className="bg-gray-100 p-4 rounded w-full">
            <div className="text-base font-semibold mb-2">
              TechForge Pvt Ltd
            </div>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="flex-1">
                <div className="text-sm text-gray-500 mb-1">Email Address</div>
                <div className="bg-white p-2 rounded">somesh@gmail.com</div>
              </div>
              <div className="flex-1">
                <div className="text-sm text-gray-500 mb-1">Project Type</div>
                <div className="bg-white p-2 rounded">CNC Machining</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerProfileScreen;
